import React from 'react';
import { Link } from '../../routing';
import './HomePage.scss';

interface HomePageProps { menuOpen: boolean; }

const services = [
  { title: 'Commercial Video', subtitle: 'Films for brands, products and campaigns.', path: '/videography' },
  { title: 'FPV', subtitle: 'Immersive fly-throughs and dynamic movement.', path: '/fpv' },
  { title: 'Drone', subtitle: 'Aerial coverage for spaces, places and projects.', path: '/drone' },
  { title: 'Events & Weddings', subtitle: 'Thoughtful films built around the day.', path: '/weddings' }
];

const HomePage: React.FC<HomePageProps> = ({ menuOpen }) => (
  <div className={`home-page ${menuOpen ? 'menu-open' : ''}`}>
    <div className="home-page__slide">
      <picture>
        <source media="(max-width: 768px)" srcSet="https://f003.backblazeb2.com/file/StageDoorMediaVideos/Photo/DJI_0109-2.jpg" />
        <img className="home-page__image" src="https://f003.backblazeb2.com/file/StageDoorMediaVideos/Photo/DJI_0109-2.jpg" alt="Aerial view of a cinematic landscape" />
      </picture>
      <div className="home-page__shade" />
      <div className="home-page__hub-content">
        <p className="home-page__hub-eyebrow">STAGE DOOR MEDIA</p>
        <h1>Cinematic video.<br /><span>A different perspective.</span></h1>
        <p className="home-page__hub-intro">Commercial filmmaking, FPV drone tours and aerial content that bring spaces, places and stories to life.</p>
        <nav className="home-page__hub-services" aria-label="Services">
          {services.map(service => (
            <Link key={service.path} to={service.path} className="home-page__hub-service">
              <span className="home-page__hub-service-title">{service.title}</span>
              <span className="home-page__hub-service-subtitle">{service.subtitle}</span>
              <span className="home-page__hub-service-arrow" aria-hidden="true">→</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  </div>
);

export default HomePage;
